<ng-container *ngFor="let addressType of viewableAddressTypes">
    <h2>{{(addressType && addressType.displayValue)}} Address</h2>
    <p-table #dt [value]="addresses | addressType:addressType"
             [globalFilterFields]="['addressLine1','addressLine2', 'city', 'state', 'postalZipCode', 'county', 'country', 'updatedDate', 'updatedBy']">
        <ng-template pTemplate="caption">
            <div class="row">
                <div class="col-sm-6 col-md-3">
                    <input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dt.filterGlobal($event.target.value, 'contains')">
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th>Address</th>
                <th>Ste, Apt, Etc.</th>
                <th>City</th>
                <th>State</th>
                <th>ZIP Code</th>
                <th>County</th>
                <th>Country</th>
                <th>Updated</th>
                <th class="td--hover-show">Updated By</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="9">
                    No records found
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-data>
            <tr [pSelectableRow]="data">
                <td>{{data.addressLine1}}</td>
                <td>{{data.addressLine2}}</td>
                <td>{{data.city}}</td>
                <td>{{data.state}}</td>
                <td>{{data.postalZipCode | zipCode}}</td>
                <td>{{data.county}}</td>
                <td>{{data.country}}</td>
                <td>{{data.updatedDate | dateTime}}</td>
                <td class="td--hover-show">{{data.updatedBy}}</td>
            </tr>
        </ng-template>
    </p-table>
</ng-container>
